import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,

  loading: false,

  accesses: [],
  roles: [],

  cans: [],
  access: false,
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },


  intersection(state){
    var cans = [];
    var roles = []
    if (state.roles)
      roles = state.roles
    var accesses = []
    if (state.accesses)
      accesses = state.accesses

    for (var i in roles) {
      if(accesses.indexOf(roles[i]) != -1)
        cans.push(roles[i]);
    }
    state.cans =  cans.sort((x,y) => x-y);
  },
  checkIntersection(state){
    if(state.cans.length)
      state.access = true
    else
      state.access = false
  },
}

export default new Vuex.Store({
  state,
  mutations
})